import MacOS from "./components/macOS";
import ReactGA from "react-ga";

const trackingID = "G-2NTXN19HX6"

function App() {
  return <MacOS />;
}

export default App;
